module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e15-4a7ef298c42b94789311789b4d2666cf.jpg";